import { appConst } from "./AppConst";

/**
 * Nạp CẤU HÌNH GIAO DIỆN từ máy chủ rồi ghi đè lên `appConst`.
 *
 * VÌ SAO: tên đơn vị, logo, bộ màu, cờ phân quyền... vốn nằm trong file .env — đổi một chữ là
 * phải build lại và triển khai lại cả bản web. Nay quản trị sửa ngay trên màn Cấu hình.
 *
 * ★ Chỉ ghi đè khóa CÓ GIÁ TRỊ. Khóa để rỗng nghĩa là "chưa khai" ⇒ giữ nguyên giá trị .env,
 *   nên đơn vị chưa cấu hình gì thì giao diện y như cũ.
 * ★ Gọi TRƯỚC khi render (xem index.tsx): màu và tên đơn vị phải đúng ngay từ MÀN ĐĂNG NHẬP,
 *   không được nhấp nháy đổi màu sau khi trang đã hiện.
 * ★ Lỗi mạng / API chưa có thì BỎ QUA, chạy tiếp bằng .env — không được để cả ứng dụng trắng màn
 *   chỉ vì không lấy được cấu hình trang trí.
 */
export interface ICauHinhGiaoDien {
  ten_don_vi?: string;
  co_quan_chu_quan?: string;
  logo?: string;
  bo_anh_banner?: string;
  mau_chu_dao?: string;
  mau_chuyen_sac?: string;
  mau_chu_menu_cha?: string;
  mau_ten_phan_mem?: string;
  mau_chu_header?: string;
  mau_phu?: string;
  bat_phan_quyen_menu?: string;
  hien_chuong_thong_bao?: string;
  hien_thong_bao_goc_man?: string;
  kieu_giao_dien?: string;
  header_dong_tren?: string;
  header_ten_he_thong?: string;
  header_nhan_manh?: string;
  header_ten_phan_mem?: string;
  header_cho_phep_trong?: string;
  anh_nen_header?: string;
  anh_nen_header_vi_tri?: string;
  anh_nen_header_kich_thuoc?: string;
  anh_nen_header_lap?: string;
  anh_nen_header_do_mo?: string;
  anh_nen_menu?: string;
  anh_nen_menu_vi_tri?: string;
  anh_nen_menu_kich_thuoc?: string;
  anh_nen_menu_lap?: string;
  anh_nen_menu_do_mo?: string;
}

/** Khóa cấu hình (máy chủ) → thuộc tính trong appConst. */
export const ANH_XA: Array<[keyof ICauHinhGiaoDien, keyof typeof appConst]> = [
  ["ten_don_vi", "NAME_UNIT"],
  ["co_quan_chu_quan", "GOV_NAME"],
  ["logo", "LOGO"],
  ["bo_anh_banner", "THEME"],
  ["mau_chu_dao", "THEME_COLOR_PRIMARY"],
  ["mau_chuyen_sac", "THEME_COLOR_HOVER"],
  ["mau_chu_menu_cha", "THEME_COLOR_TEXT_PARENT"],
  ["mau_ten_phan_mem", "THEME_COLOR_PRODUCT"],
  ["mau_chu_header", "THEME_COLOR_HEADER"],
  ["mau_phu", "THEME_COLOR_PRIMARY_HOVER"],
  ["bat_phan_quyen_menu", "MENU_PHAN_QUYEN"],
  ["hien_chuong_thong_bao", "IS_SHOW_NOFITICATION"],
  ["hien_thong_bao_goc_man", "HIEN_THONG_BAO_GOC_MAN"],
  ["kieu_giao_dien", "THEME_LAYOUT"],
  // Chữ trên thanh trên cùng — Header2/Header3 đọc thẳng appConst (đã có useTheoDoiGiaoDien).
  ["header_dong_tren", "HEADER_DONG_TREN"],
  ["header_ten_he_thong", "HEADER_TEN_HE_THONG"],
  ["header_nhan_manh", "HEADER_NHAN_MANH"],
  ["header_ten_phan_mem", "HEADER_TEN_PHAN_MEM"],
  ["header_cho_phep_trong", "HEADER_CHO_PHEP_TRONG"],
  // Ảnh nền thanh trên cùng + menu trái — Header2/Header3 và Layout đọc thẳng từ appConst
  // (đều có useTheoDoiGiaoDien) nên KHÔNG cần biến CSS riêng.
  ["anh_nen_header", "THEME_BG_HEADER"],
  ["anh_nen_header_vi_tri", "THEME_BG_HEADER_POSITION"],
  ["anh_nen_header_kich_thuoc", "THEME_BG_HEADER_SIZE"],
  ["anh_nen_header_lap", "THEME_BG_HEADER_REPEAT"],
  ["anh_nen_header_do_mo", "THEME_BG_HEADER_OPACITY"],
  ["anh_nen_menu", "THEME_BG_MENU"],
  ["anh_nen_menu_vi_tri", "THEME_BG_MENU_POSITION"],
  ["anh_nen_menu_kich_thuoc", "THEME_BG_MENU_SIZE"],
  ["anh_nen_menu_lap", "THEME_BG_MENU_REPEAT"],
  ["anh_nen_menu_do_mo", "THEME_BG_MENU_OPACITY"],
];

/**
 * Ảnh chụp giá trị MẶC ĐỊNH cài sẵn trong bản web (.env), lấy NGAY lúc nạp module — tức trước khi
 * `taiCauHinhGiaoDien` ghi đè. Màn Cấu hình dùng nó để nhắc "để trống thì đang dùng giá trị nào",
 * nếu đọc thẳng appConst lúc đó thì đã là giá trị đã bị ghi đè, không còn là mặc định nữa.
 */
export const MAC_DINH_ENV: Record<string, string> = ANH_XA.reduce(
  (gom, [khoaCauHinh, khoaAppConst]) => {
    gom[khoaCauHinh] = ((appConst as any)[khoaAppConst] ?? "").toString();
    return gom;
  },
  {} as Record<string, string>,
);

/**
 * Giá trị ĐANG CHẠY của trang (env đã chồng cấu hình đã lưu). Dùng để hoàn nguyên khi người dùng
 * tắt "xem thay đổi ngay" — không thể hoàn về MAC_DINH_ENV vì như vậy là xoá luôn cấu hình đã lưu.
 */
const DANG_CHAY: Record<string, string> = { ...MAC_DINH_ENV };

/**
 * Các ô CHỮ TRÊN THANH TRÊN CÙNG mà đơn vị được quyền để TRỐNG HẲN (ẩn dòng đó) thay vì lùi về
 * chữ mặc định.
 *
 * ★ VÌ SAO PHẢI KHAI TƯỜNG MINH: luật chung của màn Cấu hình là "ô rỗng = chưa khai ⇒ dùng mặc
 *   định .env". Luật đó đúng cho tên đơn vị / logo / màu, nhưng với mấy dòng chữ trang trí thì
 *   đơn vị có thể MUỐN bỏ hẳn dòng đó đi — mà xóa trắng thì lại thấy chữ mặc định hiện lại.
 *   Nên phải có chỗ nói rõ "ô NÀY tôi cố ý để trống", chứ không đoán mò từ giá trị rỗng.
 */
export const KHOA_CO_THE_TRONG: Array<keyof ICauHinhGiaoDien> = [
  "ten_don_vi",
  "header_dong_tren",
  "header_ten_he_thong",
  "header_nhan_manh",
  "header_ten_phan_mem",
];

/**
 * `header_cho_phep_trong` lưu DANH SÁCH khóa được để trống, ngăn nhau bằng dấu phẩy
 * (vd "ten_don_vi,header_nhan_manh") — cho phép bật/tắt TỪNG Ô chứ không phải cả cụm.
 * Chỉ nhận khóa nằm trong {@link KHOA_CO_THE_TRONG}: khóa lạ lọt vào là mở đường xóa trắng
 * cả logo / màu, những thứ luôn phải có giá trị.
 */
export const tachChoPhepTrong = (chuoi?: string | null): Set<string> => {
  const ds = (chuoi ?? "")
    .split(",")
    .map((x) => x.trim())
    .filter((x) => (KHOA_CO_THE_TRONG as string[]).includes(x));
  return new Set(ds);
};

const layChoPhepTrong = (data: ICauHinhGiaoDien) =>
  tachChoPhepTrong(
    (data as any)?.HEADER_CHO_PHEP_TRONG ?? data?.header_cho_phep_trong,
  );

export const taiCauHinhGiaoDien = async (): Promise<void> => {
  try {
    // Gọi fetch trần, KHÔNG qua apiClient: apiClient gắn token và có thể đẩy về màn đăng nhập
    // khi 401 — trong khi đây là API công khai, chạy trước cả lúc đăng nhập.
    const res = await fetch(`${appConst.baseApiURL}/cau-hinh-giao-dien`, {
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return;
    const body = await res.json();
    const data: ICauHinhGiaoDien = body?.data ?? body ?? {};

    const choPhepTrong = layChoPhepTrong(data);
    ANH_XA.forEach(([khoaCauHinh, khoaAppConst]) => {
      // ★ Máy chủ trả tên thuộc tính VIẾT HOA (TEN_DON_VI) vì serialize giữ nguyên tên thuộc
      //   tính C#, không đổi sang chữ thường. Đọc cả hai kiểu cho chắc.
      const goc = data as any;
      const giaTri = goc?.[khoaCauHinh.toUpperCase()] ?? goc?.[khoaCauHinh];
      if (typeof giaTri !== "string") return;
      // Bình thường ô rỗng = "chưa khai" nên bỏ qua (giữ mặc định). Chỉ khi đơn vị BẬT cờ
      // "cho phép để trống" thì ô rỗng của mấy dòng chữ header mới được ghi đè thành rỗng thật.
      const nhanRong = choPhepTrong.has(khoaCauHinh);
      if (giaTri.trim() === "" && !nhanRong) return;
      (appConst as any)[khoaAppConst] = giaTri.trim();
      DANG_CHAY[khoaCauHinh] = giaTri.trim();
    });
  } catch {
    // Không lấy được cấu hình -> chạy bằng .env, đừng chặn ứng dụng.
  }
};

/* ==========================================================================================
 * XEM THAY ĐỔI NGAY — người dùng gõ tới đâu thấy tới đó, chưa cần bấm Lưu.
 * ========================================================================================== */

/** Khóa cấu hình → biến CSS mà App.tsx khai ở :root. */
const BIEN_CSS: Partial<Record<keyof ICauHinhGiaoDien, string>> = {
  mau_chu_dao: "--primary",
  mau_chuyen_sac: "--bg_hover",
  mau_chu_menu_cha: "--text_parent",
  mau_ten_phan_mem: "--color_product",
  mau_chu_header: "--color_header",
  mau_phu: "--primary_hover",
};

/**
 * KHÔNG xem thử được cờ phân quyền menu: đổi nóng cờ này là bộ gác đường dẫn tính lại quyền và
 * có thể đá người dùng khỏi chính màn Cấu hình đang mở. Muốn đổi thì Lưu rồi tải lại trang.
 */
const KHONG_XEM_THU: Array<keyof ICauHinhGiaoDien> = ["bat_phan_quyen_menu"];

/** Các thành phần đang hiển thị (thanh trên cùng...) đăng ký để vẽ lại khi giá trị đổi. */
const nguoiNghe = new Set<() => void>();
let phienBan = 0;

export const dangKyDoiGiaoDien = (bao: () => void) => {
  nguoiNghe.add(bao);
  return () => {
    nguoiNghe.delete(bao);
  };
};

export const layPhienBanGiaoDien = () => phienBan;

const bao = () => {
  phienBan += 1;
  nguoiNghe.forEach((f) => f());
};

/**
 * Ghi 1 khóa vào appConst + biến CSS tương ứng. `giaTri` rỗng ⇒ trả về mặc định .env,
 * TRỪ mấy ô chữ header khi đơn vị đã bật "cho phép để trống" — lúc đó rỗng là rỗng thật.
 */
const ap = (
  khoa: keyof ICauHinhGiaoDien,
  giaTri: string,
  choPhepTrong: Set<string> = new Set(),
) => {
  const anhXa = ANH_XA.find(([k]) => k === khoa);
  if (!anhXa) return;
  const nhanRong = choPhepTrong.has(khoa);
  const thuc = nhanRong
    ? (giaTri ?? "").trim()
    : (giaTri ?? "").trim() || MAC_DINH_ENV[khoa] || "";
  (appConst as any)[anhXa[1]] = thuc;

  const bien = BIEN_CSS[khoa];
  const goc = document.documentElement.style;
  if (bien) {
    // Đặt thẳng lên thẻ gốc: kiểu nội tuyến thắng khối :root mà App.tsx sinh ra, nên không cần
    // dựng lại cây React chỉ để đổi màu.
    goc.setProperty(bien, thuc || (khoa === "mau_chu_header" ? "#fff" : ""));
  }
  if (khoa === "bo_anh_banner") {
    goc.setProperty("--bg_header", `url(/imageStyle/${thuc}/banner.png)`);
    goc.setProperty("--bg_header_left", `url(/imageStyle/${thuc}/bannerLeft.png)`);
  }
};

/** Áp tạm cấu hình đang gõ dở lên giao diện thật. */
export const xemThuGiaoDien = (data: ICauHinhGiaoDien) => {
  const choPhepTrong = layChoPhepTrong(data);
  ANH_XA.forEach(([khoa]) => {
    if (KHONG_XEM_THU.includes(khoa)) return;
    ap(khoa, (data as any)[khoa] ?? "", choPhepTrong);
  });
  bao();
};

/** Bỏ xem thử: trả giao diện về đúng cấu hình đang chạy của trang. */
export const thoiXemThuGiaoDien = () => {
  const goc = document.documentElement.style;
  Object.values(BIEN_CSS).forEach((bien) => bien && goc.removeProperty(bien));
  goc.removeProperty("--bg_header");
  goc.removeProperty("--bg_header_left");

  ANH_XA.forEach(([khoa, khoaAppConst]) => {
    (appConst as any)[khoaAppConst] = DANG_CHAY[khoa] ?? "";
  });
  bao();
};

/** Sau khi Lưu thành công: coi giá trị vừa lưu là giá trị đang chạy. */
export const ghiNhanDaLuuGiaoDien = (data: ICauHinhGiaoDien) => {
  const choPhepTrong = layChoPhepTrong(data);
  ANH_XA.forEach(([khoa]) => {
    const giaTri = ((data as any)[khoa] ?? "").trim();
    DANG_CHAY[khoa] = choPhepTrong.has(khoa)
      ? giaTri
      : giaTri || MAC_DINH_ENV[khoa] || "";
  });
};
